import React from "react";
import { Container, Paper, Typography } from "@material-ui/core";
import { useStyles } from "../../assets/styles";
import FindUser from "./FindUser";
import AssignStore from "./AssignStore";

function AddStoreToUser() {
	const classes = useStyles();
	return (
		<Container className={classes.root}>
			<Paper className={classes.paper}>
				<Typography variant="h5">Asignar restaurante a un usuario</Typography>
				<FindUser />
				<AssignStore />
			</Paper>
		</Container>
	);
}

export default AddStoreToUser;
